module.exports = {"371526001":"鱼邱湖街道","371526002":"汇鑫街道","371526003":"人和街道","371526101":"梁村镇","371526102":"尹集镇","371526103":"清平镇","371526104":"固河镇","371526105":"三十里铺镇","371526106":"琉璃寺镇","371526107":"赵寨子镇","371526108":"姜店镇","371526109":"杨屯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371526.json
// module id = 1610
// module chunks = 0